import { React, useState } from 'react'
import CardHeadMenu from '../../Components/Card/CardHeadMenu/CardHeadMenu'
import { AnimatePresence } from "framer-motion";
import DesignationCard from './DesignationCard';
import DesignationTable from './DesignationTable';

const DesignationPage = () => {
    const [isCreate, setIsCreate] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [loading, setLoading] = useState(true);
    const [editData, setEditData] = useState({});
    const [fetchTableDataTrue, setFetchTableDataTrue] = useState(false);


    const handlePopup = () => {
        setIsCreate(!isCreate); // Toggles the visibility of the MenuCard
        setIsEdit(false);
    };
    const fetchTableData = () => {
        setFetchTableDataTrue(prev => !prev); // Toggle the state to trigger re-fetch in DesignationTable
    };

    const handleEdit = (data) => {
        setEditData(data);
        setIsEdit(true);
        setIsCreate(true);
    };

    return (

        <>
            <CardHeadMenu
                prefix={"Na"}
                suffix={"Na"}
                title={"DESIGNATION"}
                handlePopup={handlePopup}
                create={isCreate}
               
            />
            <AnimatePresence>
                {isCreate && (
                    <DesignationCard
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        editData={editData}
                        isCreate={isCreate} // State passed as a prop
                        setIsCreate={setIsCreate} // Function passed as a prop
                        fetchTableData={fetchTableData}
                        setEditData={setEditData}
                    />
                )}
            </AnimatePresence>

            <DesignationTable fetchTableDataTrue={fetchTableDataTrue}
                handleEdit={handleEdit}
            />



        </>
    )
}

export default DesignationPage   
